import { InformationForBorrowingTestContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingTestContainer";

export function InformationForBorrowingTestPage () {

    return(
        <InformationForBorrowingTestContainer/>
    )
}




